import { render } from "./InfoModal.vue?vue&type=template&id=8fb34008&scoped=true"
import script from "./InfoModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InfoModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=8fb34008&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb34008"]])

export default __exports__